import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export const AuthGuard = (props) => {
  const { children } = props;
  const navigate = useNavigate();

  const isAuthenticated = localStorage.getItem("authenticated")
    ? localStorage.getItem("authenticated") === "true"
    : false;

  const ignore = useRef(false);
  const [checked, setChecked] = useState(false);

  // Only do authentication check on component mount.
  // This flow allows you to manually redirect the user after sign-out, otherwise this will be
  // triggered and will automatically redirect to sign-in page.
  useEffect(() => {
    // Prevent from calling twice in development mode with React.StrictMode enabled
    if (ignore.current) {
      return;
    }

    ignore.current = true;

    if (!isAuthenticated) {
      navigate("/auth/login", {
        state: {
          continueUrl:
            window.location.pathname !== "/"
              ? window.location.pathname
              : undefined,
        },
      });
    } else {
      setChecked(true);
    }
  }, []);

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // authenticated / authorized.

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
